import { Link, Navigate } from 'react-router-dom'
import Page from '../components/layout/Page'
import Content from '../components/layout/Content'
import ProtectedRoute from '../helpers/ProtectedRoute'
import { Media } from '../types/User'
import styles from '../styles/Home.module.css'

function Home() {
  const STORAGE_KEY = 'media'
  const localStorageMedia = localStorage.getItem(STORAGE_KEY)
  let media: Media | null = null
  if (localStorageMedia) {
    try {
      media = JSON.parse(localStorageMedia)
    } catch (error) {
      console.log(error)
    }
  }
  const stores = media?.stores ?? []

  if (stores.length === 1) {
    const [currentStore] = stores
    const { id } = currentStore || {}
    return <Navigate to={`/${id}`} />
  }

  return (
    <ProtectedRoute user={media?.token}>
      <Page>
        <div className={styles.home}>
          {stores.length > 1 ? (
            <Content>
              <h1 className={styles.heading}>Välj butik</h1>
              <ul className={styles.list}>
                {stores.map(({ id, name }) => (
                  <li className={styles.item} key={id}>
                    <Link className={styles.link} to={`/${id}`}>
                      {name}
                    </Link>
                  </li>
                ))}
              </ul>
            </Content>
          ) : null}
        </div>
      </Page>
    </ProtectedRoute>
  )
}

export default Home
